import AppContainer from '@Containers/AppContainer';
import { init } from '@Containers/InitContainer';
import React from "react";
import { createRoot } from 'react-dom/client';
import '../css/admin.css';

void init();

const el = document.getElementById('app');

if (el) {
    createRoot(el).render(<AppContainer />);
}
